import { render, staticRenderFns } from "./DoctorInfoTempForm.vue?vue&type=template&id=e65da6e2&"
import script from "./DoctorInfoTempForm.vue?vue&type=script&lang=js&"
export * from "./DoctorInfoTempForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports